import { Component, Input, OnInit } from '@angular/core';
import { FileUploadMetadataLego } from '../../shared/dto/file-upload-metadata-lego';

@Component({
  selector: 'wl-file-upload-lego-summary',
  templateUrl: './file-upload-lego-summary.component.html',
  styleUrls: ['./file-upload-lego-summary.component.less'],
    standalone: false
})
export class FileUploadLegoSummaryComponent implements OnInit {
  @Input() fileUploadData: FileUploadMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
